import { withOctopus } from '../../utils/octopus';

import PluginCoreDesktop from './plugins/CORE/defs/desktop';
import PluginOficialStoreDesktop from './plugins/OFFICIAL_STORE/defs/desktop';

const HeaderDesktop = withOctopus({ debugMode: false, componentName: 'Header' }, PluginCoreDesktop);

export { HeaderDesktop, PluginOficialStoreDesktop };
